export const GameCssStyles = {
    container: {
        padding: '40px 0px 0px 0px',
        textAlign: 'center',
    },
    containerStyle_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 2,
    },
    containerStyleNoPadding_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 0,
    },
    containerStyleColumn_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 2,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2
    },
    containerStyleColumnWithoutBorderNoColor_sx: {
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2
    },
    containerStyleColumnWithoutBorder_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2
    },
    containerStyleRow_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 2,
        display: "flex",
        flex: 1,
        flexDirection: "row",
        gap: 2
    },
    containerStyleRowWithoutBorderNoColor_sx: {
        //backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "row",
        gap: 2
    },
    containerStyleRowWithoutBorder_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "row",
        gap: 2
    },
    inputLabelStyle_sx: {
        color: 'text.secondary',
        '&.Mui-focused': {
            color: 'text.secondary', // Change color on focus
        },
    },
    menuItemStyle_sx: {
        '&.Mui-selected': {
            color: 'text.primary',
            textAlign: 'left'
        },
    },
    formFiledStyle_sx: {
        '& .MuiSelect-select': {
            color: 'text.primary', // Text color
            borderWidth: '1px',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'text.primary', // Default outline
            borderWidth: '1px',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'text.primary', // Outline when focused
            borderWidth: '1px',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'text.primary', // Outline on hover
            borderWidth: '1px',
        },
        '& label.Mui-focused': {
            color: 'text.primary',
        },
    },
    formFiledStyle_sx2: {
        '& .MuiSelect-select': {
            color: 'text.primary', // Text color
            borderWidth: '1px',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'text.primary', // Default outline
            borderWidth: '1px',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'text.primary', // Outline when focused
            borderWidth: '1px',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'text.primary', // Outline on hover
            borderWidth: '1px',
        },
        '& label.Mui-focused': {
            color: 'text.primary',
        },
        textAlign: 'left',
        '& .MuiSelect-select': {
            textAlign: 'left',
        }
    },
    formSingleLineTextField_sx: {
        '& .MuiOutlinedInput-root': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'text.primary',
                borderWidth: '1px',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'text.primary',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'text.primary',
            },
        },
        '& .MuiInputBase-root': {
            color: 'text.primary',
            borderWidth: '1px',
        },
        '& label.Mui-focused': {
            color: 'text.primary',
        }
    },
    formMultiLineTextField_sx: {
        '& .MuiOutlinedInput-root': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'text.primary', // Your desired color
                borderWidth: '1px',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'text.primary',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'text.primary',
            },
        },
        '& .MuiInputBase-root': {
            resize: 'vertical', // Allow vertical resizing
            overflow: 'auto',   // Show scrollbars if needed
            color: 'text.primary',
            borderWidth: '1px',
        },
        '& label.Mui-focused': {
            color: 'text.primary',
        },
    },
    radioButtonStyle_sx: {
        color: 'text.primary', // default color
        '&.Mui-checked': {
            color: 'text.primary', // when checked
        },
        '&:hover': {
            backgroundColor: 'transparent', // optional: avoid default grey bg
        },
    },
    switchStyle_sx: {
        '& .MuiSwitch-switchBase': {
            color: 'text.primary',
            '&.Mui-checked': {
                color: '#097becff',
            },
            '&.Mui-checked + .MuiSwitch-track': {
                backgroundColor: '#097becff',
            },
        },
        '& .MuiSwitch-track': {
            backgroundColor: '#727272ff', // fallback color for unchecked
        },
    }
}